import { ClassicGame } from '~/store/classic.svelte';
import { lettersToBoard, type TileSpec } from '~/board/utils';
import type { Board, Coord, Freqs, Match, Tile, WordSort } from '~/types';

export class ClassicTutorial extends ClassicGame {
  // Letters that will be drawn in order when refilling the board. When
  // exhausted, sampleLetter falls back to the static fallback letter.
  letterQueue: TileSpec[] = [];
  fallbackLetter: TileSpec = 'X';

  constructor(board: Board, queue: TileSpec[] = []) {
    super();
    this.turns = 0;
    this.board = board;
    this.dims = [board.length, board[0].length];
    this.letterQueue = queue;
  }

  override sampleLetter(_board: Board, _rng: () => number): [Freqs<string>, Tile] {
    const spec = this.letterQueue.shift() ?? this.fallbackLetter;
    const [tile] = lettersToBoard([[spec]], 'classic')[0];
    return [{} as Freqs<string>, tile];
  }

  // No-op persistence so tutorial state never hits IndexedDB.
  override async save() { }
  override async appendTurn(_coords: Coord[] = [], _duration?: number) { }
  override async appendWord(_word: Match) { this.words++; }
  override async getPage(_sort: WordSort, _offset: number, _pageSize = 10): Promise<Match[]> { return []; }
  override async getAll(_index?: WordSort, _fromIndex?: number): Promise<Match[]> { return []; }
}
